export default __webpack_public_path__ + "static/media/Navneet-with-dog-landscape.b179e150.jpg";